import React from "react";
import { bool, elementType, func, node, object, string } from "prop-types";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import InfoIcon from "@mui/icons-material/Info";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { tooltipStyles, popoverStyles } from "../component-styles";
import { blurFocusedPopover } from "../utils/focus";

export const closePopoverWithFocusReset =
  (closePopover) =>
  (...args) => {
    blurFocusedPopover();
    closePopover(...args);
  };

export default function CustomPopover(props) {
  const {
    title = "",
    data = {},
    content = "",
    id = "",
    controlHeight = true,
    contentReversed = false,
    icon = null,
  } = props;

  const generatedPopupId = React.useId();
  const popupId = id || generatedPopupId;

  const PopoverTrigger = React.forwardRef(function TooltipContent(props, ref) {
    const Icon = icon || InfoIcon;
    return (
      // `props` here is whatever bindTrigger()/bindPopover() (below) hand us —
      // open-ended by design, since material-ui-popup-state owns that shape.
      <Box
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        ref={ref}
        sx={[
          controlHeight ? tooltipStyles.root : tooltipStyles.rootNoMinHeight,
          contentReversed && tooltipStyles.reversed,
          popoverStyles.trigger,
        ]}
      >
        {title}
        <Icon sx={[tooltipStyles.icon, contentReversed && tooltipStyles.iconLeft]} />
      </Box>
    );
  });

  return (
    <PopupState variant="popover" popupId={popupId}>
      {(popupState) => {
        const popoverProps = bindPopover(popupState);

        return (
          <div>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <PopoverTrigger {...bindTrigger(popupState)} />
            <Popover
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...popoverProps}
              onClose={closePopoverWithFocusReset(popoverProps.onClose)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              sx={{
                ...popoverStyles.root,
                "& .MuiPaper-root": popoverStyles.paper,
              }}
              elevation={2}
            >
              <Box sx={{ p: 2, ...popoverStyles.box }}>{content(popoverStyles, data)}</Box>
            </Popover>
          </div>
        );
      }}
    </PopupState>
  );
}

CustomPopover.propTypes = {
  title: node,
  data: object,
  content: func,
  id: string,
  controlHeight: bool,
  contentReversed: bool,
  icon: elementType,
};
